import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";

const HISTORY = `${config.POSTLOGIN_API_URL_COMPANY}reminders/history`;

/**
 * Fetches a page of email send history, newest first.
 * @param {number} page 1-based page number.
 * @param {number} pageSize rows per page.
 * @param {string} status optional status filter ("pending" | "sent" | "failed").
 * @returns {Promise<object>} the apiCall result.
 */
export const listEmailHistory = (page = 1, pageSize = 25, status = "") => {
  const query = new URLSearchParams({ page, pageSize });
  if (status) query.set("status", status);
  return apiCall(`${HISTORY}?${query.toString()}`, {}, {}, "GET");
};
